import APITemplate from '@api/APITemplate'
import { diffTimeMinutes, formatQueryParams } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { crm } from '@modules/crm/constants/URL'

class APICrmRelationshipKanban extends APITemplate {
  constructor() {
    super()

    this.MODULE = 'crm'
    this.reqCarregar = null

    // STORE KEYS
    this.KEY_DATA = `${this.MODULE}/relationshipKanban`
    this.KEY_LOADING = `${this.MODULE}/relationshipKanbanLoading`
    this.KEY_LAST_UPDATE = `${this.MODULE}/relationshipKanbanLastUpdate`

    // STORE ACTIONS
    this.ACTION_SET_DATA = `${this.MODULE}/setRelationshipKanban`
    this.ACTION_SET_LOADING = `${this.MODULE}/setRelationshipKanbanLoading`
    this.ACTION_ADD = `${this.MODULE}/addRelationshipKanban`
  }

  // ---------- HELPERS ----------
  shouldUseCache(forceUpdate) {
    if (forceUpdate) return false

    return !diffTimeMinutes(
      store.getters[this.KEY_LAST_UPDATE],
      MINUTES_TIMEOUT_REQUESTS
    )
  }

  setDataFromResponse(r) {
    if (r && r.status === 200) {
      const data = (r.value && r.value.etapas) || []
      store.dispatch(this.ACTION_SET_DATA, data)
      return
    }

    store.dispatch(this.ACTION_SET_DATA, [])
  }

  async getEarlyResponse(forceUpdate) {
    if (this.reqCarregar) {
      const r = await this.reqCarregar
      return (
        r ||
        this.buildErrorResponse({
          message: 'Erro ao carregar dados',
        })
      )
    }

    if (this.shouldUseCache(forceUpdate)) {
      return this.buildSuccessResponse({
        message: 'Dados carregados da memória',
        value: store.getters[this.KEY_DATA],
      })
    }

    if (store.getters[this.KEY_LOADING]) {
      return this.buildSuccessResponse({
        message: 'Requisição em andamento, dados carregados da memória',
        value: store.getters[this.KEY_DATA],
      })
    }

    return null
  }

  resolveUrl(filters) {
    const params = {}
    if (filters) {
      params.filters = JSON.stringify(filters)
    }
    return crm.clientsKanban + formatQueryParams(params)
  }

  // ---------- REQUESTS ----------
  async carregar({ forceUpdate = false, filters = null } = {}) {
    const earlyResponse = await this.getEarlyResponse(forceUpdate)
    if (earlyResponse) return earlyResponse

    store.dispatch(this.ACTION_SET_LOADING, true)

    this.reqCarregar = con.get(this.resolveUrl(filters))
    const r = await this.reqCarregar

    this.setDataFromResponse(r)

    store.dispatch(this.ACTION_SET_LOADING, false)
    this.reqCarregar = null

    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao carregar dados',
      })
    )
  }

  // Fetch de kanban de 1 cliente (id_cliente_app). Não dispara mutação — controller faz o upsert.
  async carregarCliente({ idClienteApp, filters = null } = {}) {
    if (!idClienteApp) {
      return this.buildErrorResponse({
        message: 'Cliente inválido.',
        status: 400,
      })
    }

    const mergedFilters = {
      ...(filters && typeof filters === 'object' ? filters : {}),
      id_cliente_app: idClienteApp,
    }

    const r = await con.get(this.resolveUrl(mergedFilters))
    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao carregar kanban do cliente',
      })
    )
  }
}

const apiCrmRelationshipKanban = new APICrmRelationshipKanban()
export { apiCrmRelationshipKanban }
